import React, { useEffect } from 'react';
import 'jquery';
import { HashRouter, BrowserRouter, Switch, Route } from 'react-router-dom';
import { GlobalRoutes } from './routes';
import PaymentVerifier from './pages/paymentverifier';
import { Provider } from 'react-redux';
import { PersistGate } from 'redux-persist/integration/react';
import store, { persistor } from './redux/reduxstore';

export default () => {
  useEffect(() => {
    // Paystack Script Injection
    const script = document.createElement('script');
    script.src = 'https://js.paystack.co/v1/inline.js';
    script.async = true;
    document.body.appendChild(script);

    // Leaflet CSS Injection
    const leafletCss = document.createElement('link');
    leafletCss.rel = 'stylesheet';
    leafletCss.href = 'https://unpkg.com/leaflet@1.9.4/dist/leaflet.css';
    document.head.appendChild(leafletCss);

    // Optional cleanup on unmount
    return () => {
      if (document.body.contains(script)) {
        document.body.removeChild(script);
      }
      if (document.head.contains(leafletCss)) {
        document.head.removeChild(leafletCss);
      }
    };
  }, []);

  return (
    <Provider store={store}>
      <PersistGate loading={null} persistor={persistor}>
        <BrowserRouter>
          <Switch>
            <Route path="/paymentverifier" component={PaymentVerifier} />
            <HashRouter>
              <GlobalRoutes />
            </HashRouter>
          </Switch>
        </BrowserRouter>
      </PersistGate>
    </Provider>
  );
};
